import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Platform-wide list of *enabled* languages, fetched from the admin-managed
 * `platform_languages` collection. Replaces the hard-coded fr/en/mg array.
 *
 * Hardcoded fallback: if the API call fails (e.g. cold start / network),
 * we still ship fr/en/mg so the UI never breaks.
 */
const FALLBACK = {
  items: [
    { code: 'fr', name: 'Français',  is_default: true,  enabled: true },
    { code: 'en', name: 'English',   is_default: false, enabled: true },
    { code: 'mg', name: 'Malagasy',  is_default: false, enabled: true },
  ],
  default: 'fr',
};

// Flag emoji per common code. Used by the switcher; codes without a
// match fall back to the 🌐 globe icon.
const FLAGS = {
  fr: '🇫🇷', en: '🇬🇧', mg: '🇲🇬',
  pt: '🇵🇹', es: '🇪🇸', de: '🇩🇪', it: '🇮🇹', zh: '🇨🇳',
};
export const flagFor = (code) => FLAGS[code] || '🌐';

const LanguagesContext = createContext({ ...FALLBACK, loading: true });

export const LanguagesProvider = ({ children }) => {
  const [state, setState] = useState({ ...FALLBACK, loading: true });

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/languages`).then((res) => {
      if (cancelled) return;
      const data = res.data || {};
      const items = Array.isArray(data.items) && data.items.length ? data.items : FALLBACK.items;
      setState({
        items,
        default: data.default || FALLBACK.default,
        loading: false,
      });
    }).catch(() => {
      if (cancelled) return;
      setState({ ...FALLBACK, loading: false });
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <LanguagesContext.Provider value={state}>
      {children}
    </LanguagesContext.Provider>
  );
};

export const useLanguages = () => useContext(LanguagesContext);
